<template>
  <div :style="`text-align:${column.align}`">{{ absenceDuration }}</div>
</template>
<script>
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';

export default {
  name: 'AbsenceDuration',
  props: {
    absence: Object,
    column: Object,
    isDisabled: { type: Boolean, default: false },
  },
  mixins: [wsMixin],
  computed: {
    absenceDuration() {
      return this.mx_absenceDuration(this.absence);
    },
  },
};
</script>
